// extracted by mini-css-extract-plugin
export default {"Craps":"Craps_Craps__epEl7","holder":"Craps_holder__npepF","questionHolder":"Craps_questionHolder__qB9Y9"};